import { makeStyles } from '@/styles/theme/tss-react';

import { darkOrLightStyle } from '@/utils/styles';

interface Props {
  isOnDark: boolean | undefined;
}

const useStyles = makeStyles<Props>({
  name: 'TextList',
})(({ brandColors, spacing }, props) => ({
  textList: {
    padding: `${spacing(2)} 0`,
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      width: '100%',
      bottom: 0,
      borderBottom: darkOrLightStyle(props)(
        '1px solid rgba(255, 255, 255, 0.30)',
        '1px solid rgba(0, 0, 0, 0.20)'
      ),
    },
  },
  textListHeading: {
    color: darkOrLightStyle(props)(brandColors.white, brandColors.black),
  },
  textListBody: {
    color: darkOrLightStyle(props)(
      brandColors.tintsOffWhite40,
      brandColors.tintsNeutral20
    ),
  },
}));

export default useStyles;
